export interface CountdownDate {
    startDate: string;
    endDate: string;
    fromHour: number;
    fromMinutes: number;
}

export enum TypeOfDate {
    local,
    spain,
    configuration,
}

export interface CountDownRender {
    seconds: number;
    minutes: number;
    hours: number;
    days: number;
    secondsView?: string;
    minutesView?: string;
    hoursView?: string;
    daysView?: string;
    isOnTime?: boolean;
}
